var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-card"},[_c('div',{staticClass:"ui-card-body"},[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{staticClass:"ui-card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }